import { useRef } from "react";
import { Play, Pause, RotateCcw, Maximize } from "lucide-react";
import AppShell from "@/components/AppShell";
import useCountdown from "@/lib/useCountdown";

const TIMES = [1, 2, 3, 5, 10];
const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

export default function Cronometro() {
  const { duration, remaining, running, setDuration, start, pause, reset } = useCountdown(300);
  const boxRef = useRef(null);

  const fullscreen = () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else boxRef.current?.requestFullscreen?.();
  };

  return (
    <AppShell active="material">
      <div ref={boxRef} className="relative bg-obsidian rounded-2xl overflow-hidden" data-testid="cronometro-box">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <img src="/assets/logo.jpeg" alt="" className="w-[55%] max-w-lg opacity-[0.07] rounded-full" />
        </div>

        <div className="relative p-8 sm:p-12 text-center">
          <h1 className="font-display text-xl font-bold" data-testid="cronometro-title">Cronômetro</h1>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mt-1">CONTAGEM REGRESSIVA DE TREINO</p>

          <p className={`mt-10 font-mono font-bold text-8xl sm:text-9xl tracking-wider ${remaining <= 10 && remaining > 0 ? "text-crimson" : "text-[#F5F5F0]"}`} data-testid="cronometro-timer">
            {fmt(remaining)}
          </p>

          <div className="mt-8 flex items-center justify-center gap-2 flex-wrap" data-testid="cronometro-times">
            {TIMES.map((m) => (
              <button
                key={m}
                type="button"
                onClick={() => setDuration(m * 60)}
                data-testid={`cronometro-time-${m}`}
                className={`font-mono text-sm tracking-wider px-5 py-2.5 rounded-full border transition-colors ${duration === m * 60 ? "border-gold bg-gold/15 text-gold" : "border-white/15 text-zinc-500 hover:border-gold/40"}`}
              >
                {m} MIN
              </button>
            ))}
          </div>

          <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
            <button
              type="button"
              onClick={running ? pause : start}
              data-testid="cronometro-start-pause"
              className="inline-flex items-center gap-2 font-display font-semibold bg-gold text-obsidian px-10 py-4 rounded-full hover:bg-gold-amber transition-colors text-lg"
            >
              {running ? <Pause size={20} /> : <Play size={20} />} {running ? "Pausar" : "Iniciar"}
            </button>
            <button type="button" onClick={reset} data-testid="cronometro-reset" className="inline-flex items-center gap-2 font-mono text-xs tracking-widest border border-white/15 text-zinc-300 px-6 py-4 rounded-full hover:border-crimson/60 hover:text-crimson transition-colors">
              <RotateCcw size={14} /> ZERAR
            </button>
            <button type="button" onClick={fullscreen} data-testid="cronometro-fullscreen" className="inline-flex items-center gap-2 font-mono text-xs tracking-widest border border-white/15 text-zinc-300 px-6 py-4 rounded-full hover:border-gold/50 hover:text-gold transition-colors">
              <Maximize size={14} /> TELA CHEIA
            </button>
          </div>

          <p className="mt-8 font-mono text-[11px] text-zinc-600" data-testid="cronometro-note">
            BEEPS NOS ÚLTIMOS 10 SEGUNDOS · ALARME AO ZERAR
          </p>
        </div>
      </div>
    </AppShell>
  );
}
